import NoveltyIntensityPqChartGroup from './NoveltyIntensityPqChartGroup';
export default NoveltyIntensityPqChartGroup;